/* eslint-disable camelcase */
import React, { useEffect, useState } from "react"
import types from "prop-types"
import { AccessLevelSelect } from "shared/selects"
import * as API from "services/api"
import { submissionAccessLevel } from "./utils"
import AccessExplanation from "./AccessExplanation"

const AccessLevelIdentifier = ({
  className = "",
  categoryGrant = null,
  formGrant = null,
  formSubmissionGrant = null,
  selectLabel = "",
  updateAccessGranteeLists,
  formSubmissionSlug,
  isDisabled,
  granteeType,
  granteeId,
}) => {
  const applicableGrant = submissionAccessLevel({ categoryGrant, formGrant, formSubmissionGrant })
  const { accessLevel, id, grantor } = applicableGrant

  const [currentApplicableGrantId, setCurrentApplicableGrantId] = useState(id)

  useEffect(() => {
    setCurrentApplicableGrantId(id)
  }, [id])

  const manageSubmissionAccessGrant = async (newAccessLevel) => {
    // Checks if accessGrant is the same from previous renders to prevent unnecessary update on delete
    if (currentApplicableGrantId !== id) {
      setCurrentApplicableGrantId(id)
      return
    }

    // only send request if grantor or access level have changed
    if ((grantor === "formSubmissionGrant") && (accessLevel === newAccessLevel)) {
      return
    }

    const accessLevelGrant = { access_level: newAccessLevel, grantee_type: granteeType, grantee_id: granteeId }

    const response = await API.manageFormSubmissionAccessGrant({
      formSubmissionSlug, accessLevelGrant,
    })
    if (response.ok) {
      updateAccessGranteeLists(response.data)
    } else {
      console.error("Error updating access level grant", response)
    }
  }

  return (
    <div className={className}>
      <AccessExplanation
        categoryGrant={categoryGrant}
        formGrant={formGrant}
        formSubmissionGrant={formSubmissionGrant}
      />
      <AccessLevelSelect
        value={accessLevel}
        onChange={manageSubmissionAccessGrant}
        isDisabled={isDisabled}
        selectLabel={selectLabel}
      />
    </div>
  )
}

/* eslint-disable react/forbid-prop-types */
AccessLevelIdentifier.propTypes = {
  className: types.string,
  categoryGrant: types.object,
  formGrant: types.object,
  formSubmissionGrant: types.object,
  updateAccessGranteeLists: types.func.isRequired,
  granteeType: types.string.isRequired,
  granteeId: types.number.isRequired,
  formSubmissionSlug: types.string.isRequired,
  isDisabled: types.bool.isRequired,
  selectLabel: types.string,
}
/* eslint-enable react/forbid-prop-types */

export default AccessLevelIdentifier
